<template>
  <div class="evaluation-page w100 pl20 pr20 pt20 pb20">
    <div class="card">
      <div class="hr-wrap pl20 pt20 pb20">
        <span class="start-hr"></span>
        <span class="pl20 pr20">教师统计信息</span>
        <span class="end-hr mr20"></span>
      </div>
      <el-form :label-position="labelPosition" :model="formLabelAlign">
        <!-- <el-form-item>
          <el-col :span="7">
            <el-form-item label="学习效果:" label-width="80px" >
              <el-input readOnly v-model="formLabelAlign.learnEffect" class="grayBlue"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="1">&nbsp;</el-col>
          <el-col :span="7">
            <el-form-item label="师生互动:" label-width="80px" >
              <el-input readOnly v-model="formLabelAlign.interaction"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="1">&nbsp;</el-col>
          <el-col :span="8">
            <el-form-item label="个人能力提升:" label-width="120px">
              <el-input readOnly v-model="formLabelAlign.personalAbility"></el-input>
            </el-form-item>
          </el-col>
        </el-form-item> -->
        <el-form-item>
          <el-col :span="7">
            <el-form-item label="总分:" label-width="80px" >
              <!-- <el-input readOnly v-model="formLabelAlign.learnEffect" class="grayBlue"></el-input> -->
              100分
            </el-form-item>
          </el-col>
          <el-col :span="1">&nbsp;</el-col>
          <el-col :span="7">
            <el-form-item label="得分:" label-width="80px" >
              {{formLabelAlign.learnEffect}}
              <!-- <el-input readOnly v-model="formLabelAlign.interaction"></el-input> -->
            </el-form-item>
          </el-col>
          <el-col :span="1">&nbsp;</el-col>
          <el-col :span="8">
            <!-- <el-form-item label="个人能力提升:" label-width="120px">
              <el-input readOnly v-model="formLabelAlign.personalAbility"></el-input>
            </el-form-item> -->
          </el-col>
        </el-form-item>
        <el-form-item>
          <el-col :span="7">
            <el-form-item label="平均分:" label-width="80px" >
              <el-input readOnly v-model="formLabelAlign.avgScore"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="1">&nbsp;</el-col>
          <el-col :span="7">
            <el-form-item label="评分人数:" label-width="80px" >
              <el-input readOnly v-model="formLabelAlign.peopleNumber"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="1">&nbsp;</el-col>
          <el-col :span="8">
            <el-form-item label="评分次数:" label-width="120px">
              <el-input readOnly v-model="formLabelAlign.evaluaNumber"></el-input>
            </el-form-item>
          </el-col>
        </el-form-item>
      </el-form>
    </div>
    <div class="pt20">
        <el-table class="table"
          border
          :data="tableData"
          style="width: 100%">
          <el-table-column
            label="序号"
            align="center"
            type="index"
            width="50">
            <template slot-scope="scope">
                {{ paramSearch.current * paramSearch.size - paramSearch.size + scope.$index + 1 }}
            </template>
          </el-table-column>
          <el-table-column
            prop="userName"
            align="center"
            label="姓名"
            width="100"
            :formatter="formatName">
          </el-table-column>
          <el-table-column
            prop="learnEffect"
            align="center"
            label="评教分数"
            width="100">
          </el-table-column>
          <el-table-column
            prop="remark"
            align="center"
            label="反馈意见">
          </el-table-column>
          <el-table-column
            prop="createTime"
            align="center"
            label="评教时间"
            width="200">
          </el-table-column>
          <el-table-column
            align="center"
            label="操作"
            width="100">
            <template slot-scope="scope">
              <el-button plain @click="detailClick(scope.row)">详情</el-button>
            </template>
          </el-table-column>
          <!-- <el-table-column
            prop="interaction"
            align="center"
            label="师生互动"
            width="100">
          </el-table-column>
          <el-table-column
            prop="personalAbility"
            align="center"
            label="能力提升分数"
            width="180">
          </el-table-column>
          <el-table-column
            prop="createTime"
            align="center"
            label="评教时间">
          </el-table-column> -->
        </el-table>
       </div>

    <div class="mt20 flex-box">
        <div class="flex-1"></div>
        <el-pagination background @size-change="changeSize"
            @current-change="changePage"
            :current-page="paramSearch.current"
            :page-sizes="pageSizes"
            :page-size="paramSearch.size"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
        ></el-pagination>
    </div>
      <editComment :mentData="mentData" :info="info" v-if="mentData.state" :id="id"/>
  </div>
</template>
<script>
  import * as api from '@/api/overseasChinese/overseasChinese'
  import editComment from "./../../editComment.vue"
  export default {
    components:{
      editComment
    },
    props: {
      info: {
        type: Object,
        default () {
            return {};
        }
      },
    },
    data() {
      return {
        labelPosition: 'right',
        formLabelAlign: {
          avgScore: 0,
          evaluaNumber: 0,
          interaction: 0,
          learnEffect: 0,
          peopleNumber: 0,
          personalAbility: 0,
        },
        loading: false,
        pageSizes:[10, 20, 30, 50, 100],
        paramSearch:{
            current:1,
            size:10,
        },
        total: 0,
        tableData: [],
        mentData:{
            state: false,
            data:{}
        },
        id:""
      };
    },
    created() {
      this.getDetail()
      this.initPage()
    },
    methods: {
      initPage() {
        // let {day, pkteachclassid, termid, timeType, week } = JSON.parse(this.$route.query.info)
        let {day, pkteachclassid, termid, timeType, week } = this.info
        this.paramSearch = {
          ...this.paramSearch,
          day,
          pkteachclassid,
          // semesterId: termid,
          timeType,
          week
        }
        this.paramSearch.semesterId = termid
        this.getEvaluationScorePage()
      },
      getDetail() {
        // let {day, pkteachclassid, semesterId, timeType, week } = JSON.parse(this.$route.query.info)
        let {day, pkteachclassid, termid, timeType, week } = this.info
        let semesterId = termid
        api.selectEvaluaDetails({
          day,
          pkteachclassid,
          semesterId,
          timeType,
          week
        }).then(res => {
          if(res.data.code == 0) {
            console.log(res)
            this.formLabelAlign = res.data.data
          }
        })
      },
      getEvaluationScorePage() {
        this.loading = true
        api.selectEvaluaScorePage(this.paramSearch).then(res => {
          this.loading = false
          if(res.data.code == 0) {
            this.tableData = res.data.data.records || []
            this.total = res.data.data.total
          }
        })
        .catch(()=> {
          this.loading = false
        })
      },
      changeSize(value) {
        this.paramSearch.size = value
        this.paramSearch.current = 1
        this.getEvaluationScorePage()
      },
      changePage(value) {
        this.paramSearch.current = value
        this.getEvaluationScorePage()
      },
      formatName(row) {
        switch(row.anonymousFlag) {
          case '1':
            return '匿名'
          case '0':
            return row.userName
          default: 
            return ""
        }
      },
      detailClick(val){
        console.log(val)
        this.id = val.id
        this.mentData.state = true;
      }
    },
  }
</script>
<style lang="less" scoped>
::v-deep .el-form-item--small.el-form-item {
  margin-left: 18px;
  margin-right: 18px;
}
::v-deep .el-table--border {
  border-left: none
}
.evaluation-page {
  height: 100%;
  .card {
    width: 88%;
    height: 200px;
    margin: 0 auto;
    border: 1px solid #eeeeee;
    box-shadow: 5px 5px 5px #eeeeee;
    border-radius: 4px;
    .hr-wrap {
      display: flex;
      align-items: center;
      .start-hr {
        width: 2%;
        height: 1px;
        background: #eeeeee;
      }
      .end-hr {
        flex: 1;
        height: 1px;
        background: #eeeeee;
      }
    }
  }
  .table {
    width: 88% !important;
    margin: 0 auto;
  }
  .grayBlue {
    background: #F5F7FA !important;
  }
}

</style>